export { default as StudentDiscountModal } from "./StudentDiscountModal";

export type { StudentDiscountModalProps } from "./StudentDiscountModal";
export { STUDENT_DISCOUNT_MODAL_ID } from "./StudentDiscountModal";
